import {
  PAYROLL_LOADING,
  GET_VACATIONS,
  GET_CAFETERIA,
  GET_PAYLIST,
  GET_CAFETERIA_DETAIL,
  GET_YEAR_BONUS,
  RESET_STORAGE,
  ERROR,
  GET_BONUS,
  RESET_BONUS
} from "../actions/PayrollActions";

const initialState = {
  loading: false,
  success: true,
  errorMessage: "",
  vacations: [],
  cafeteria: null,
  cafeteriaDetail: null,
  paylist: [],
  yearBonus: [],
  isError: false,
  bonus: [],
};

const PayrollReducer = function (state = initialState, action) {
  switch (action.type) {
    case PAYROLL_LOADING: {
      return {
        ...state,
        loading: true,
        isError: false,
      };
    }
    case GET_VACATIONS: {
      return {
        ...state,
        vacations: [...action.data],
        loading: false,
      };
    }
    case GET_CAFETERIA: {
      return {
        ...state,
        cafeteria: action.data,
        loading: false,
      };
    }
    case GET_CAFETERIA_DETAIL: {
      return {
        ...state,
        cafeteriaDetail: action.data,
        loading: false,
      };
    }
    case GET_PAYLIST: {
      return {
        ...state,
        paylist: [...action.data],
        loading: false,
      };
    }
    case GET_YEAR_BONUS: {
      return {
        ...state,
        yearBonus: [...action.data],
        loading: false,
      };
    }
    case RESET_STORAGE: {
      return {
        state: initialState,
      };
    }
    case GET_BONUS: {
      return {
        ...state,
        bonus: [...action.data],
        loading: false,
      };
    }
    case ERROR: {
      return {
        ...state,
        isError: true,
        loading: false,
      };
    }
    case RESET_BONUS: {
      return {
        ...state,
        isError: false,
        bonus:[]
      }
    }
    default: {
      return state;
    }
  }
};

export default PayrollReducer;
